import {
  listingFields,
  FACTURACION_SCALE,
  ANTIGUEDAD_SCALE,
  EMPLEADOS_SCALE,
} from '../config/configListing';
import { isFieldForListingType } from './fieldHelpers';
import { MANDATO_RANGE_GROUPS } from './mandatoRanges';

/** Validate a saved Uroborox draft before requesting publication; returns field keys only. */
export const listingPublicationErrors = listing => {
  const { title, publicData: data = {} } = listing?.attributes || {};
  const errors = [];
  if (!['free-listing', 'mandato-compra'].includes(data.listingType)) return ['listingType'];
  if (typeof title !== 'string' || !title.trim()) errors.push('title');
  for (const field of listingFields) {
    if (!field.saveConfig?.isRequired || !isFieldForListingType(data.listingType, field)) continue;
    const value = data[field.key];
    const known = v =>
      (field.enumOptions || []).some(
        o =>
          (o.option === v &&
            !(
              field.key === 'sector' &&
              data.listingType === 'free-listing' &&
              o.suboptions?.length
            )) ||
          (o.suboptions || []).some(child => child.option === v)
      );
    const valid =
      field.schemaType === 'enum'
        ? known(value)
        : field.schemaType === 'multi-enum'
        ? Array.isArray(value) && value.length > 0 && value.every(known)
        : field.schemaType === 'long'
        ? Number.isInteger(value)
        : field.schemaType === 'boolean'
        ? typeof value === 'boolean'
        : typeof value === 'string' && value.trim().length > 0;
    if (!valid) errors.push(field.key);
  }
  if (data.listingType === 'mandato-compra') {
    for (const { minKey, maxKey, scale } of MANDATO_RANGE_GROUPS) {
      const allowed = value => scale.some(t => t.idx === value);
      if (!allowed(data[minKey]) || !allowed(data[maxKey]) || data[minKey] > data[maxKey]) {
        errors.push(minKey, maxKey);
      }
    }
    const provinces = data.provincias;
    if (
      Array.isArray(provinces) &&
      (provinces.length > 3 || (provinces.includes('toda-espana') && provinces.length > 1))
    )
      errors.push('provincias');
  } else {
    for (const [key, indexKey, scale, matchKey] of [
      ['facturacion', 'facturacionIdx', FACTURACION_SCALE, 'option'],
      ['antiguedad', 'antiguedadIdx', ANTIGUEDAD_SCALE, 'option'],
      ['empleados', 'empleadosIdx', EMPLEADOS_SCALE, 'lowerBound'],
    ]) {
      const row = scale.find(t => t[matchKey] === data[key]);
      if (!row || row.idx !== data[indexKey]) errors.push(key, indexKey);
    }
  }
  return [...new Set(errors)];
};
